var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLossicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#45272E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1354 19.9062C15.2809 19.9062 15.4151 19.8282 15.4871 19.7018L18.4149 14.5627C18.803 13.8815 18.9658 13.0951 18.8802 12.3157L18.5712 9.50377C18.5162 9.00346 18.1235 8.60717 17.6237 8.54771L15.7712 8.32735C14.5484 8.18189 13.3085 8.30798 12.1399 8.69665C11.5628 8.8886 11.1006 9.32662 10.8779 9.89256L9.38681 13.6818C9.35035 13.7744 9.32516 13.8711 9.31177 13.9698C9.19868 14.8029 9.92797 15.5056 10.7563 15.3618L13.7451 14.8427C14.6893 14.6787 15.5047 15.5118 15.3204 16.4522L14.7382 19.4236C14.6892 19.6736 14.8806 19.9062 15.1354 19.9062ZM16.6276 20.3515C16.3221 20.8877 15.7525 21.2187 15.1354 21.2187C14.0545 21.2187 13.2423 20.232 13.4502 19.1712L14.0324 16.1998C14.0349 16.1871 14.0336 16.1793 14.0318 16.1738C14.0297 16.1669 14.0252 16.1588 14.0179 16.1513C14.0106 16.1439 14.0026 16.1393 13.9958 16.137C13.9903 16.1351 13.9825 16.1336 13.9697 16.1358L10.9809 16.6549C9.27799 16.9507 7.77871 15.5059 8.0112 13.7932C8.03873 13.5904 8.09052 13.3917 8.16547 13.2012L9.65654 9.41196C10.0217 8.48408 10.7795 7.76594 11.7257 7.45124C13.0774 7.00163 14.5117 6.85577 15.9263 7.02404L17.7787 7.2444C18.8849 7.37599 19.7542 8.25309 19.8758 9.36041L20.1848 12.1724C20.3007 13.2268 20.0804 14.2908 19.5553 15.2124L16.6276 20.3515Z",
    fill: "#FD504F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossicon);
export default __webpack_public_path__ + "static/media/lossicon.75a0d081afd758ae57462ef1647cf18a.svg";
export { ForwardRef as ReactComponent };